jQuery.extend({

    ajaxPoller: function(options) {
        this.defaults = {
            interval: 1000,
            timeout: 30000,
            exponentialBackoff: false,
            successCondition: function() { return true; },
            success: function() {},
            error: function() {}
        };

        this.options = $.extend(true, {}, this.defaults, options);
        this.nextInterval = this.options.interval;
        this.timerId = null;    // Useful to capture in case you want to implement an overall timeout - you can pass
        // it to clearTimeout() to kill the corresponding setTimeout() task.

        this.doPoll = function() {
            $.ajax({
                type: "GET",
                dataType: "json",
                url: this.options.url,
                success: function (data, textStatus, jqXHR ) {

                    var conditionMet = this.options.successCondition(data);

                    if (conditionMet) {
                        this.options.success(data);
                    }
                    else {
                        this.timerId = setTimeout(function () {
                            this.doPoll();
                        }.bind(this), this.nextInterval);
                    }
                }.bind(this),
                failure: function (jqXHR, textStatus, errorThrown) {
                    if (this.options.error) {
                        this.options.error(errorThrown);
                    }
                    else {
                        throw new Error(errorThrown);
                    }
                }.bind(this),
                complete: function() {
                    this.nextInterval = this.options.exponentialBackoff ? this.nextInterval * 1.5 : this.options.interval;
                }.bind(this)
            });
        };

        this.doPoll();

    }

});